export const setupSticky = (): void => {
  document
    .querySelectorAll<HTMLElement>("[data-sticky-container]")
    .forEach((container) => {
      container.querySelectorAll<HTMLElement>("[data-sticky]").forEach((e) => {
        const update = (): void => {
          const { top, bottom } = container.getBoundingClientRect();
          const height =
            e
              .querySelector<HTMLElement>("[data-sticky-height]")
              ?.getBoundingClientRect()?.height ??
            e.getBoundingClientRect().height;

          if (bottom < height) {
            e.classList.remove("is-sticky");
            e.classList.add("is-sticky-bottom");
          } else if (top < 0) {
            e.classList.add("is-sticky");
            e.classList.remove("is-sticky-bottom");
          } else {
            e.classList.remove("is-sticky");
            e.classList.remove("is-sticky-bottom");
          }
        };

        window.addEventListener("scroll", update);
        window.addEventListener("resize", update);
        update();
      });
    });
};
